export const PASSWORD_MIN_LENGTH = 12;

export function passwordPolicyError(value) {
  const password = String(value || "");
  if (password.length < PASSWORD_MIN_LENGTH) return `Şifre en az ${PASSWORD_MIN_LENGTH} karakter olmalıdır`;
  if (password.length > 128) return "Şifre en fazla 128 karakter olabilir";
  const classes = [
    /[a-z]/.test(password),
    /[A-Z]/.test(password),
    /\d/.test(password),
    /[^A-Za-z0-9]/.test(password),
  ];
  if (classes.filter(Boolean).length < 3) {
    return "Şifre büyük/küçük harf, rakam ve sembol gruplarından en az üçünü içermelidir";
  }
  return "";
}
